module.exports = __webpack_public_path__ + "static/img/son2_active.d0c68fbe.png";